import { render, staticRenderFns } from "./confirmList.vue?vue&type=template&id=1990d7ed&scoped=true&"
import script from "./confirmList.vue?vue&type=script&lang=js&"
export * from "./confirmList.vue?vue&type=script&lang=js&"
import style0 from "./confirmList.vue?vue&type=style&index=0&id=1990d7ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990d7ed",
  null
  
)

export default component.exports